import { PermutLogo } from "assets/logo"
import { ReactElement } from "react"
import { AuthBackground } from "./AuthBackground"

export const AuthWrapper = ({ children }: { children: ReactElement }) => {
  return (
    <div className="relative flex min-h-svh w-screen items-center justify-center sm:py-12">
      <AuthBackground />
      <div className="flex flex-col justify-center items-center md:w-auto w-full sm:max-w-lg h-full sm:h-auto overflow-y-auto sm:rounded-xl p-16 z-10 md:bg-background/65 bg-background/30 shadow-[0_20px_160px_#00000030] border-background/30 border backdrop-blur-lg">
        <div className="flex flex-col justify-between gap-8 h-auto max-w-85 w-full min-w-[320px] [&_input]:duration-150 [&_input]:border-foreground/15 [&_input:focus]:ring-foreground/10">
          <div className="flex flex-col h-full items-center">
            <PermutLogo square className="size-20" />
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}
